namespace GeniuzPOS.Product {
    export interface CsPluForm {
        SkuCode: Serenity.StringEditor;
        PluCode: Serenity.StringEditor;
        PluShortDesc: Serenity.StringEditor;
        PluDesc: Serenity.TextAreaEditor;
        StyleId: Serenity.LookupEditor;
        ColorId: Serenity.LookupEditor;
        SizeId: Serenity.LookupEditor;
        TasteId: Serenity.LookupEditor;
        MatTypeId: Serenity.LookupEditor;
        SellUnit: Serenity.LookupEditor;
        SellUnitRatio: Serenity.DecimalEditor;
        DeliverCost: Serenity.DecimalEditor;
        PluType: Serenity.RadioButtonEditor;
        SellUnitPrice1: Serenity.DecimalEditor;
        SellUnitPrice2: Serenity.DecimalEditor;
        SellUnitPrice3: Serenity.DecimalEditor;
        SellUnitPrice4: Serenity.DecimalEditor;
        SellUnitPrice5: Serenity.DecimalEditor;
        SellUnitPrice6: Serenity.DecimalEditor;
        ActiveSellFg: Serenity.BooleanEditor;
    }

    export class CsPluForm extends Serenity.PrefixedContext {
        static formKey = 'Product.CsPlu';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CsPluForm.init)  {
                CsPluForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.TextAreaEditor;
                var w2 = s.LookupEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.RadioButtonEditor;
                var w5 = s.BooleanEditor;

                Q.initFormType(CsPluForm, [
                    'SkuCode', w0,
                    'PluCode', w0,
                    'PluShortDesc', w0,
                    'PluDesc', w1,
                    'StyleId', w2,
                    'ColorId', w2,
                    'SizeId', w2,
                    'TasteId', w2,
                    'MatTypeId', w2,
                    'SellUnit', w2,
                    'SellUnitRatio', w3,
                    'DeliverCost', w3,
                    'PluType', w4,
                    'SellUnitPrice1', w3,
                    'SellUnitPrice2', w3,
                    'SellUnitPrice3', w3,
                    'SellUnitPrice4', w3,
                    'SellUnitPrice5', w3,
                    'SellUnitPrice6', w3,
                    'ActiveSellFg', w5
                ]);
            }
        }
    }
}
